import { PatchTripType } from '@orbit/api-types'
import api from '@lib/api'
import { invalidateMembership } from '@hooks/useJoinRequests'
import { queryKeys } from '@lib/queryKeys'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { Trip } from '@types'

export const useUpdateTrip = (tripId: string) => {
	const queryClient = useQueryClient()

	return useMutation<Trip, Error, PatchTripType>({
		mutationFn: async (tripData) => {
			const response = await api.patch<Trip>(`/trips/${tripId}`, tripData)
			return response.data
		},
		onSuccess: (updatedTrip, tripData) => {
			queryClient.invalidateQueries({ queryKey: queryKeys.trip(tripId) })
			queryClient.invalidateQueries({ queryKey: queryKeys.trips() })
			// The trip-settings modal opens from the trip home, so the bento is
			// still mounted and its own mount-time revalidation will not fire.
			queryClient.invalidateQueries({ queryKey: queryKeys.tripOverview(tripId) })
			queryClient.setQueryData(queryKeys.trip(tripId), updatedTrip)
			// Turning Join approval off lets everyone waiting in, server side; turning
			// it on changes nobody's membership.
			if (tripData.joinApprovalRequired === false) {
				queryClient.invalidateQueries({ queryKey: queryKeys.joinRequests(tripId) })
				invalidateMembership(queryClient, tripId)
			}
		},
	})
}

